<section class="section" style="margin-top: 30px;">
    <div class="container" style="text-align: center;">
        <div class="notification movement">
            <h1>Our Team</h1>
        </div>
        <h2 class="movement-des">
            <h6>Content About the Team</h6>
        </h2>
    </div>
</section>
<section id="team">
    <div class="card">
        <img src="../../../assets/img/sujithbg.png" alt="" />
        <div class="data">
            <h2>Sujith</h2>
            <i>BEING Abundance Council member </i>
            <p>Sujith Ravindran is a bestselling serial author, a speaker and trainer in the field of Personal
                Development and Abundance thinking. For his contribution to personal growth and social development,
                Sujith was conferred the honour of AMBASSADOR OF PEACE in 2012 by the Council of Assisi in Italy. He is
                a co-creator of the internationally recognized HUMAN POTENTIAL Assessment which have been used to
                support business, governmental and non-profit organizations across 5 continents on their reinvention.
            </p>
        </div>
    </div>
    <div class="card">
        <img src="../../../assets/img/Steve.jpg" alt="" />
        <div class="data">
            <h2>Steve</h2>
            <i>BEING Abundance Council member</i>
            <p>Living and born in Belgium. Father of 2 fantastic childeren. Professionally active as a sales person.
                Briony invited me to follow an online training about abundance with Sujith. The 7 mystical laws of
                abundance really inspired me and touched my heart. It's not just new knowledge for me, I really try to
                implement it in my life, step by step. So honored to be part of this team. </p>
        </div>
    </div>
    <div class="card">
        <img src="../../../assets/img/Patricia.JPG" alt="" />
        <div class="data">
            <h2>Patricia</h2>
            <i>BEING Abundance Council member</i>
            <p>Consciousness worker, Abundance networker, angel and transformer. Been active in education and in
                business. Writing, communication, abundance, shamanism, being creative with color are some of my
                passions.
                Life is full of twists and turns and surprises. From my experiences and wisdom, I like to support
                organizations and individual adults and children.</p>
        </div>
    </div>
    <div class="card">
        <img src="../../../assets/brionybg.jpg" alt="" />
        <div class="data">
            <h2>Briony</h2>
            <i>BEING Abundance Council member</i>
            <p>Briony is a visionary, international entrepreneur, trainer and creator of the Quantum Shift method. She
                is an expert in business and educational innovation and trains entrepreneurs in business expansion and
                quantum thinking. She founded an innovative primary school in Belgium and was several years director.
                She launched during the last 12 years various initiatives with events up to 3000 visitors in the field
                of education and business. She is singer-songwriter, author of 'Unlimited Growth of your company' and
                multiple children books. She created multiple innovative educational methods where cognitive skills,
                artistic expression and personal development are integrated in stories and fairy tales.</p>
        </div>
    </div>
    <div class="card">
        <img src="../../../assets/img/Navneesh.jpg" alt="" />
        <div class="data">
            <h2>Navneesh</h2>
            <i>BEING Abundance Council member</i>
            <p>While growing up as a child, the inner urge in me to know Who am I? Why am I here? was very intense.
                Slowly, many great masters and teacher's began showing up who gently held my hand to weave a new path. A
                path that was in alignment with the calling of my heart. In their presence and shared silence, the
                urgency and the need to find answers to my questions simply dissolved.
                Today, all my offerings for the collective good of the humanity emerge from the love that so many beings
                have showered over me especially my grandmother.
                It gives me great joy to hold space for Self Inquiry and Intuitive Healing to take place through various
                modalities like inner child work, family constellation, creative expression, healing with Nature and so
                on.
                I'm excited to participate in this grand dance of Abundance with my fellow beings to notice again and
                again how blessed we are!</p>
        </div>
    </div>
    <div class="card">
        <img src="../../../assets/img/sujithbg.png" alt="" />
        <div class="data">
            <h2>Thomas</h2>
            <i>BEING Abundance Council member</i>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit Etiam sedesmi. Consectetur elit placerat mollis
                donec dolor.</p>
        </div>
    </div>
    <div class="card">
        <img src="../../../assets/img/Ludo.JPG" alt="" />
        <div class="data">
            <h2>Ludo</h2>
            <i>BEING Abundance Council member</i>
            <p>Ludo Simons, Healing stream of the heart, dancing heart and Lotvid. In my life I received these tree
                names in budism, sjamanism and Sufism. I like to embody new counciousness and to lead from the heart.
                Best things are in silence and without a name tag on! My biggest contribution is anywhere on this
                planet. I try to become the best version of me by listening to nature, my ancestors and my vision. I am
                here to pass the stone further for the generations to come. Earthkeeper: specialised in grief and
                letting go: surving and contributing for the whole. I hope to inspire you so that you uplift the
                abundance in your life. Not in a temple but in your daily routine. experiment, Renew yourself and tapp
                into your wisdom. For me the real abundance is everything money cannot buy. I am a councious millionair.
                What is your legacy?</p>
        </div>
    </div>

</section>